import { createGlobalStyle } from "styled-components";
import {
  ALABASTER,
  EERIE_BLACK,
  GHOST_WHITE,
  PRIMARY_FONT,
  PRIMARY_SIZE,
} from "../utils/variables";

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  html,
  body,
  #root,
  main {
    position: relative;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;

    @supports (overflow: clip) {
      overflow-x: clip;
    }
  }

  html {
    font-size: 62.5%;
    background-color: #07080A;
   

  }

  section[id] {
    scroll-margin-top: 8rem;
  }

  .skip-link {
    position: fixed;
    top: 1rem;
    left: 1rem;
    z-index: 1000;
    padding: 1rem 1.4rem;
    color: ${EERIE_BLACK};
    background: ${GHOST_WHITE};
    border-radius: 0.4rem;
    font-family: ${PRIMARY_FONT};
    font-size: 1.4rem;
    text-decoration: none;
    transform: translateY(-150%);
    transition: transform 0.2s ease;
  }

  .skip-link:focus {
    transform: translateY(0);
  }

  body {
    min-height: 100vh;
    isolation: isolate;
    font-size: ${PRIMARY_SIZE};
    font-family: ${PRIMARY_FONT};
    background-color: ${EERIE_BLACK};
    background-image: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.015),
      transparent 38%,
      rgba(255, 255, 255, 0.01)
    );
    color: ${ALABASTER};

    &::before {
      content: "";
      position: fixed;
      inset: -25%;
      z-index: -2;
      pointer-events: none;
      background:
        radial-gradient(
          circle at 18% 28%,
          rgba(76, 106, 145, 0.2),
          transparent 27%
        ),
        radial-gradient(
          circle at 78% 22%,
          rgba(63, 120, 109, 0.13),
          transparent 25%
        ),
        radial-gradient(
          circle at 68% 78%,
          rgba(97, 82, 128, 0.11),
          transparent 28%
        );
      filter: blur(5rem);
      transform: translate3d(-2%, -1%, 0) scale(1.05);
      animation: ambient-gradient 20s ease-in-out infinite alternate;
      will-change: transform;
    }

    &::after {
      content: "";
      position: fixed;
      inset: 0;
      z-index: -1;
      pointer-events: none;
      opacity: 0.15;
      background-image:
        linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
      background-size: 5rem 5rem;
      mask-image: linear-gradient(to bottom, black, transparent 75%);
    }

    @keyframes ambient-gradient {
      0% {
        transform: translate3d(-3%, -2%, 0) scale(1.04) rotate(-1deg);
      }
      50% {
        transform: translate3d(3%, 2%, 0) scale(1.1) rotate(1deg);
      }
      100% {
        transform: translate3d(-1%, 4%, 0) scale(1.06) rotate(-0.5deg);
      }
    }

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${GHOST_WHITE};
      border: 3px solid ${EERIE_BLACK};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: ${EERIE_BLACK};
    }
  }

  

  .bouncing {
    display: inline-block;
    animation: rubberband 800ms alternate ease-out;

    @keyframes rubberband {
      0% {
        transform: scaleX(1);
      }
      40% {
        transform: scaleX(1.12) scaleY(0.75);
      }
      55% {
        transform: scaleX(0.85) scaleY(1);
      }
      65% {
        transform: scaleX(1.09) scaleY(0.85);
      }
      75% {
        transform: scaleX(0.9) scaleY(1);
      }
      90% {
        transform: scaleX(1.05) scaleY(0.95);
      }
      100% {
        transform: scaleX(1) scaleY(1);
      }
    }
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      scroll-behavior: auto !important;
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

`;
